import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { User } from './user';

export class VendorReview extends BaseModel {
  static VendorReviewProperties: (
    | {
        property: keyof VendorReview;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof VendorReview;
        type: 'alias';
      }
    | {
        property: keyof VendorReview;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'UserId', type: 'column', dataType: 'number' },
    { property: 'question1Score', type: 'column', dataType: 'number' },
    { property: 'question2Score', type: 'column', dataType: 'number' },
    { property: 'question3Score', type: 'column', dataType: 'number' },
    { property: 'question4Score', type: 'column', dataType: 'number' },
    { property: 'question5Score', type: 'column', dataType: 'number' },
    { property: 'question6Score', type: 'column', dataType: 'number' },
    { property: 'question7Score', type: 'column', dataType: 'number' },
    { property: 'question8Score', type: 'column', dataType: 'number' },
    { property: 'question9Score', type: 'column', dataType: 'number' },
    { property: 'question10Score', type: 'column', dataType: 'number' },
    { property: 'overallVendorRating', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'User', model: 'User', type: 'association' }
  ];

  static {
    VendorReview.VendorReviewProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        VendorReview.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        VendorReview.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        VendorReview.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(VendorReviewObject: Partial<VendorReview>) {
    super();

    VendorReview.VendorReviewProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = VendorReviewObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  VendorId?: number | null;
  CompanyId?: number | null;
  UserId?: number;
  question1Score?: number | null;
  question2Score?: number | null;
  question3Score?: number | null;
  question4Score?: number | null;
  question5Score?: number | null;
  question6Score?: number | null;
  question7Score?: number | null;
  question8Score?: number | null;
  question9Score?: number | null;
  question10Score?: number | null;
  overallVendorRating?: number | null;
  ExemptVendorId?: number | null;
  ClientRegisteredVendorId?: number | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;

  User?: User;
}
